<template>
  <div>
    <div class="columns">
      <div class="column">
        <h5 class="is-size-6 has-text-weight-light">{{ segment.hotel.hotelName }}</h5>
        <div v-if="segment.hotel.address" class="has-text-grey mb-1 is-size-7">
          <div>{{ segment.hotel.address.addressLine1 }}</div>
          <span>{{ segment.hotel.address.city }}</span>
          <span v-if="segment.hotel.address.city && segment.hotel.address.state">,</span>
          <span> {{ segment.hotel.address.state }} </span>
          <span>{{ segment.hotel.address.postalCode }}</span>
        </div>
        <div class="is-size-7 has-text-grey-dark is-block">
          Confirmation Number:

          <span class="has-text-weight-bold has-text-grey-dark">
            {{ segment.confirmationNumber }}</span>
        </div>
      </div>
      <div class="column is-narrow">
        <div class="columns mb-0">
          <div class="column is-narrow">
            <h5 class="is-size-6 mb-1">
              <span class="is-size-7 is-block has-text-grey">Check-In:</span>
              {{ segment.startDate.date | formatDate }}
            </h5>
          </div>
          <div class="column is-narrow">
            <h5 class="is-size-6 mb-1">
              <span class="is-size-7 is-block has-text-grey">Check-Out:</span>
              {{ segment.endDate.date | formatDate }}
            </h5>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full  has-text-right">
            <div>
              Rate: {{ segment.rate.amount | formatPriceFromAmount(2, segment.rate.currency) }}
            </div>
            <div class="mt-1" v-if="segment.requestedCurrencyPricing.isConverted">
               <b-tooltip type="is-dark" position="is-bottom" multilined>
                <template v-slot:content>
                  Approximate rate - The currency has been converted from {{ segment.rate.currency }} to {{
                    segment.requestedCurrencyPricing.requestedCurrency }}
                </template>
                <b-icon type="is-success" icon="approximately-equal" size="is-small">
                </b-icon>
              </b-tooltip> {{ segment.requestedCurrencyPricing.amount | formatPriceFromAmount(2,
                segment.requestedCurrencyPricing.requestedCurrency) }}
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>


</template>

<script>
export default {
  name: "ActiveHotelSegment",
  components: {},
  props: {
    segment: {
      required: true,
      type: Object,
    },
  }

};
</script>
